import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { Params, Router } from '@angular/router';

import { TranslocoService } from '@jsverse/transloco';

import { AppRoutePath } from '@cdba/app-route-path.enum';
import {
  COMPARE_ITEMS_MAX_COUNT,
  COMPARE_ITEMS_MIN_COUNT,
} from '@cdba/shared/constants/table';

import { ComparableItem } from './model/comparable-item.model';

@Component({
  selector: 'cdba-compare-button',
  templateUrl: './compare-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CompareButtonComponent {
  @Input()
  comparableItems: ComparableItem[];

  private readonly router = inject(Router);
  private readonly transloco = inject(TranslocoService);

  minCount = COMPARE_ITEMS_MIN_COUNT;
  maxCount = COMPARE_ITEMS_MAX_COUNT;

  getTooltipText(): string {
    return this.comparableItems?.length < this.minCount
      ? this.transloco.translate('shared.statusBar.hints.minCount', {
          count: this.minCount,
        })
      : this.transloco.translate('shared.statusBar.hints.maxCount', {
          count: this.maxCount,
        });
  }

  isTooltipDisabled(): boolean {
    return (
      this.comparableItems?.length >= COMPARE_ITEMS_MIN_COUNT &&
      this.comparableItems?.length <= COMPARE_ITEMS_MAX_COUNT
    );
  }

  isButtonDisabled(): boolean {
    return (
      this.comparableItems?.length < COMPARE_ITEMS_MIN_COUNT ||
      this.comparableItems?.length > COMPARE_ITEMS_MAX_COUNT
    );
  }

  showCompareView(): void {
    const queryParams: Params = {};
    const route: string[] = [AppRoutePath.ComparePath];

    this.comparableItems.forEach((item: ComparableItem, index: number) => {
      queryParams[`material_number_item_${index + 1}`] = item.materialNumber;
      queryParams[`plant_item_${index + 1}`] = item.plant;
      queryParams[`selected_calculation_id_item_${index + 1}`] =
        item.calculationId;
    });

    this.router.navigate(route, {
      queryParams,
    });
  }
}
